import { TokenVocabularyItem } from './token-chip-picker.component';

export const FILENAME_TOKEN_VOCABULARY: readonly TokenVocabularyItem[] = [
  { slug: 'barcode', label: 'barcode' },
  { slug: 'reference', label: 'reference' },
  { slug: 'description', label: 'description' },
  { slug: 'extension', label: 'File extension' },
  { slug: 'index', label: 'Numeric index' },
  { slug: 'alphabetical-index', label: 'Alphabetical index' },
];

export const FILENAME_TOKEN_VOCABULARY_WITH_CUSTOM: readonly TokenVocabularyItem[] = [
  ...FILENAME_TOKEN_VOCABULARY,
  { slug: 'custom', label: 'custom', kind: 'custom-slot' },
];
